import React, { Component } from "react";
import _ from "lodash";
import { generateId } from "./../../utils/utils";

class TableBody extends Component {
  renderCell = (item, column) => {
    if (column.content) return column.content(item);

    return _.get(item, column.path);
  };

  createKey = (item, column) => {
    return this.createItemKey(item) + (column.path || column.key);
  };

  createItemKey = (item) => {
    // return item._id || generateId();
    return generateId();
  };

  render() {
    const { data, columns } = this.props;

    return (
      <tbody>
        {data.map((item) => (
          <tr key={this.createItemKey(item)}>
            {columns.map((column) => (
              <td
                key={this.createKey(item, column)}
                className={column.className || ""}
              >
                {this.renderCell(item, column)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
}

export default TableBody;
